const useShortcut = () => null;
export default useShortcut;
